import { render, staticRenderFns } from "./problem-solving.vue?vue&type=template&id=ebdf5f00&"
import script from "./problem-solving.vue?vue&type=script&lang=js&"
export * from "./problem-solving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports